import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.filter.js";
import React from 'react';
import classNames from 'classnames';
import PureRenderMixin from './PureRenderMixin';
import assign from 'object-assign';
import Lazyload from 'react-lazy-load';
import Checkbox from '../../wui-checkbox/src';

function isRenderResultPlainObject(result) {
  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
}

var Item = /*#__PURE__*/function (_React$Component) {
  _inherits(Item, _React$Component);

  var _super = _createSuper(Item);

  function Item() {
    _classCallCheck(this, Item);

    return _super.apply(this, arguments);
  }

  _createClass(Item, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return PureRenderMixin.shouldComponentUpdate.apply(this, args);
    } // matchFilter = (text) => {
    //   const { filter, filterOption, item } = this.props;
    //   if (filterOption) {
    //     return filterOption(filter, item);
    //   }
    //   return text.indexOf(filter) >= 0;
    // }

  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          render = _this$props.render,
          filter = _this$props.filter,
          item = _this$props.item,
          lazy = _this$props.lazy,
          checked = _this$props.checked,
          prefixCls = _this$props.prefixCls,
          onClick = _this$props.onClick,
          renderedText = _this$props.renderedText,
          renderedEl = _this$props.renderedEl,
          showCheckbox = _this$props.showCheckbox,
          checkedKeys = _this$props.checkedKeys,
          isMultiDragSource = _this$props.isMultiDragSource,
          draggingItemId = _this$props.draggingItemId;
      var isAttachedDraggingItem = checked && !isMultiDragSource && draggingItemId;
      var className = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), item.disabled || isAttachedDraggingItem), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-selected"), checked && !isAttachedDraggingItem), _classNames));
      var lazyProps = assign({
        height: 32,
        offset: 500,
        throttle: 0,
        debounce: false
      }, lazy);
      var lazyFlag = true;

      if (lazy && lazy.container == "modal") {
        lazyFlag = false;
      }

      if (!lazyFlag) {
        return /*#__PURE__*/React.createElement("li", {
          className: className,
          title: renderedText,
          onClick: item.disabled ? undefined : function () {
            return onClick(item);
          }
        }, /*#__PURE__*/React.createElement(Checkbox, {
          checked: checked,
          disabled: item.disabled,
          onClick: item.disabled ? undefined : function () {
            return onClick(item);
          }
        }), /*#__PURE__*/React.createElement("span", null, renderedEl));
      } else {
        return /*#__PURE__*/React.createElement(Lazyload, lazyProps, /*#__PURE__*/React.createElement("li", {
          className: className,
          title: renderedText,
          onClick: item.disabled ? undefined : function () {
            return onClick(item);
          }
        }, showCheckbox ? /*#__PURE__*/React.createElement(Checkbox, {
          checked: checked && !isAttachedDraggingItem,
          disabled: item.disabled || isAttachedDraggingItem,
          onClick: item.disabled ? undefined : function () {
            return onClick(item);
          }
        }) : '', /*#__PURE__*/React.createElement("span", null, renderedEl), isMultiDragSource && checkedKeys.length > 1 && /*#__PURE__*/React.createElement("span", {
          className: "multi-drag-count"
        }, checkedKeys.length)));
      }
    }
  }]);

  return Item;
}(React.Component);

export default Item;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transfer/src/item.js